// src/components/CoreAssure/Kpi/KpiCategoryGroup.js
//
// Renders one KPI category (Quality / Operational / Financial-proxy)
// as a section with a label header + grid of KPI tiles.

import React from "react";
import { Box, Stack, Typography, Grid } from "@mui/material";
import KpiTile from "./KpiTile";

export default function KpiCategoryGroup({ category }) {
  if (!category || !Array.isArray(category.kpis)) return null;
  const kpis = category.kpis;
  if (kpis.length === 0) return null;

  return (
    <Box>
      <Stack direction="row" alignItems="baseline" spacing={1} sx={{ mb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {category.label || category.id}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          ({kpis.length} KPI{kpis.length === 1 ? "" : "s"})
        </Typography>
      </Stack>
      <Grid container spacing={2}>
        {kpis.map((kpi) => (
          <Grid item xs={12} sm={6} md={3} key={kpi.id || kpi.name}>
            <KpiTile kpi={kpi} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
